import { utils } from '@hh/global.js'

const { debounce } = utils

class HHFiltersWrapper extends HTMLElement {
  constructor() {
    super()
    this.filterData = []
    this.desktopFilterToggles = [...this.querySelectorAll('.js-filter')]

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)
    this.clearActiveDesktopFilterDropdownsAndSetNewOne =
      this.clearActiveDesktopFilterDropdownsAndSetNewOne.bind(this)
    this.setInitialMobileSortOption = this.setInitialMobileSortOption.bind(this)
    this.handleMobileFilterSubmit = this.handleMobileFilterSubmit.bind(this)
    this.handleBodyClick = this.handleBodyClick.bind(this)
    this.submitOnChange = this.querySelector('form').getAttribute('submitOnChange') === 'true'
    this.isMobileFilter = this.getAttribute('mobileFilter') === 'true'

    this.mobileFilterSubmit = this.querySelector(
      '.mobile-filter__actions li.js-mobile-filter-submit button'
    )

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event)
    }, 500)

    if (this.submitOnChange) {
      this.querySelector('form').addEventListener(
        'input',
        this.debouncedOnSubmit.bind(this)
      )
      this.querySelector('form').addEventListener(
        'change',
        this.debouncedOnSubmit.bind(this)
      )
    }

    window.addEventListener('popstate', this.onHistoryChange.bind(this))

    this.desktopFilterToggles.forEach((toggle) => {
      toggle.addEventListener(
        'click',
        this.clearActiveDesktopFilterDropdownsAndSetNewOne
      )
    })

    this.bindActiveFacetButtonEvents()
  }

  connectedCallback() {
    this.setInitialMobileSortOption()

    if (this.mobileFilterSubmit) {
      this.mobileFilterSubmit.addEventListener(
        'click',
        this.handleMobileFilterSubmit
      )
    }

    if (!this.isMobileFilter) {
      document.body.addEventListener('click', this.handleBodyClick)
      document.body.addEventListener('keydown', (e) => this.closeOnEscape(e))
    }
  }

  closeOnEscape(e) {
    if (e.key === 'Escape') {
      this.desktopFilterToggles.forEach((toggle) => {
        toggle.open = false
      })
    }
  }

  clearActiveDesktopFilterDropdownsAndSetNewOne(e) {
    if (e.target.tagName !== 'DETAILS') return
    e.preventDefault()

    let detail = e.currentTarget.closest('details')

    if (detail.open) {
      detail.open = false
    } else {
      if (!this.isMobileFilter) {
        this.desktopFilterToggles.forEach((toggle) => {
          toggle.open = false
        })
      }
      detail.open = true
    }
  }

  handleBodyClick(event) {
    const path = event.composedPath()
    const matchingElement = this.querySelector(
      '.collection-filters__form .filters-container'
    )
    let isWithinElement = false
    if (
      path.some((node) => {
        return node === matchingElement
      })
    ) {
      return (isWithinElement = true)
    }

    if (!isWithinElement) {
      this.desktopFilterToggles.forEach((toggle) => {
        toggle.open = false
      })
    }
  }

  setInitialMobileSortOption() {
    const url = new URL(window.location.href)

    const sortByParam = url.searchParams.get('sort_by')

    let selectTitle = this.querySelector(
      '.collection-filters__sort-container .select-title'
    )

    if (sortByParam === 'Featured' && selectTitle) {
      selectTitle.innerHTML = 'Featured'
    }

    // MOBILE SORT BY
    if (!sortByParam || sortByParam === 'Featured') {
      let firstOption = this.querySelector(
        '.collection-filters-mobile__sort-container input'
      )

      if (!firstOption) return

      firstOption.checked = true
    } else {
      let presetSortByOption = [
        ...this.querySelectorAll(
          '.collection-filters-mobile__sort-container input'
        ),
      ].filter((input) => input.value === sortByParam)?.[0]

      if (presetSortByOption) {
        presetSortByOption.checked = true
      }
    }
  }

  handleMobileFilterSubmit() {
    let sortOption = this.querySelector(
      '.collection-filters-mobile__sort-container input:checked'
    )

    let allCheckBoxes = [...this.querySelectorAll('.list-menu__item input')]
    allCheckBoxes = allCheckBoxes.filter((checkbox) => checkbox.checked)

    let newSearchUrl = ''

    allCheckBoxes.map((checkbox, index) => {
      if (index > 0) {
        newSearchUrl += '&'
      }

      newSearchUrl += `${checkbox.name}=${checkbox.value}`
    })

    if (sortOption) {
      if (allCheckBoxes.length > 0) {
        newSearchUrl += `&`
      }

      newSearchUrl += `sort_by=${sortOption.value}`
    }

    let fullUrl =
      window.location.origin + window.location.pathname + (newSearchUrl ? `?${newSearchUrl}` : '')

    window.location.href = fullUrl
  }

  onSubmitHandler(event) {
    event.preventDefault()
    const formData = new FormData(event.target.closest('form'))
    const searchParams = new URLSearchParams(formData).toString()

    this.renderPage(searchParams, event)
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    this.toggleActiveFacets()
    this.renderPage(new URL(event.currentTarget.href).searchParams.toString())
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || ''
    this.renderPage(searchParams, null, false)
  }

  toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable)
    })
  }

  renderPage(searchParams, event, updateURLHash = true) {
    document
      .getElementById('CollectionProductGrid')
      .querySelector('.js-product-grid')
      .classList.add('loading')

    const url =
      `${window.location.pathname}?` +
      this.getSections()
        .map((section) => `sections[]=${section.section}`)
        .join('&') +
      `&${searchParams}`

    const filterDataUrl = (element) => element.url === url

    this.filterData.some(filterDataUrl)
      ? this.renderSectionFromCache(filterDataUrl, event)
      : this.renderSectionFromFetch(url, event)

    if (updateURLHash) this.updateURLHash(searchParams)
  }

  renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.json())
      .then((parsed) => {
        const html = Object.values(parsed).join('')
        this.filterData = [...this.filterData, { html, url }]
        this.renderFilters(html, event)
        this.renderProductGrid(html)
      })
  }

  renderSectionFromCache(filterDataUrl, event) {
    const html = this.filterData.find(filterDataUrl).html
    this.renderFilters(html, event)
    this.renderProductGrid(html)
  }

  renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('CollectionProductGrid').innerHTML

    document.getElementById('CollectionProductGrid').innerHTML = innerHTML
  }

  renderFilters(...args) {
    this.renderSingleFormFilters('#CollectionFiltersForm', ...args)
    this.renderSingleFormFilters('#CollectionFiltersFormMobile', ...args)
  }

  renderSingleFormFilters(form, html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    const facetDetailsElements = parsedHTML.querySelectorAll(
      `${form} .js-filter`
    )
    const matchesIndex = (element) =>
      element.dataset.index ===
      event?.target.closest('.js-filter')?.dataset.index

    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    )

    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex)

    facetsToRender.forEach((element) => {
      document.querySelector(
        `${form} .js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML
    })

    this.renderActiveFacets(parsedHTML)
    this.renderDynamicBlocks(parsedHTML)

    if (countsToRender) {
      this.renderCounts(countsToRender, event.target.closest('.js-filter'))
    }
  }

  renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.js-facets--mobile',
      '.js-facets--desktop',
    ]

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    this.bindActiveFacetButtonEvents()
    this.toggleActiveFacets(false)
  }

  renderDynamicBlocks(html) {
    const resultsCountElementSelectors = [
      '.js-results--count',
      '.js-collection-load-more',
      '.js-collection-sort-by .select-title'
    ]

    resultsCountElementSelectors.forEach((selector) => {
      const resultsElement = html.querySelector(selector)
      if (!resultsElement) return
      document.querySelectorAll(selector).forEach(item => item.innerHTML = resultsElement.innerHTML)
    })
  }

  renderCounts(source, target) {
    const countElementSelectors = ['.js-bubble', '.js-selected']
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector)
      const sourceElement = source.querySelector(selector)

      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML =
          source.querySelector(selector).outerHTML
      }
    })
  }

  bindActiveFacetButtonEvents() {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick, {
        once: true,
      })
    })
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    )
  }

  getSections() {
    return [
      {
        id: 'main-collection-filters',
        section: document.getElementById('main-collection-filters').dataset.id,
      },
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset
          .id,
      },
    ]
  }
}

customElements.define('hh-filters-wrapper', HHFiltersWrapper)
